import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from 'react-localize-redux';

import SearchIcon from "../../../img/icons/VazbyVyhledavani";
import ParamsIcon from "../../../img/icons/VazbyParametry";
import SipkaIcon from "../../../img/icons/BBiconsRozbalit";

import "../../marketingList/navigator.scss";

class RelationsSearchNavigator extends Component {
    render() {
        return (
            <div className="mkt-navigator">
                <div className={`item ${this.isActive("")}`}>
                    <div className="icn"><SearchIcon /></div>
                    <div className="text">1.&nbsp;{this.getTranslate("Search")}</div>
                    <div className="text text-desc">{this.getTranslate("Search.Description")}</div>
                </div>
                <div className={`arrow ${this.stepClass}`}>
                    <SipkaIcon />
                </div>
                <div className={`item ${this.isActive("/parameters")}`}>
                    <div className="icn"><ParamsIcon /></div>
                    <div className="text">2.&nbsp;{this.getTranslate("Parameters")}</div>
                    <div className="text text-desc">{this.getTranslate("Parameters.Description")}</div>
                </div>
            </div>
        )
    }

    isActive(step) {
        const isOnParams = this.isOnParametersPage();
        if ((step === "" && !isOnParams) || (step === "/parameters" && isOnParams))
            return "active";
        return "disabled"
    }

    isOnParametersPage = () => {
        const prefix = "/search/relations";
        return this.props.match.url.indexOf(`${prefix}/parameters`) >= 0;
    }

    getTranslate = (step) => {
        const prefix = "Search.Relations.";
        return <Translate id={`${prefix}${step}`} />
    }

    get stepClass() {
        return "disabled";
    }
}

export default withRouter(withLocalize((RelationsSearchNavigator)));